<template>
  <q-layout>
    <div class="page-header">
      <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('affiliate_bonus') }}</q-toolbar-title>
      <q-breadcrumbs class="q-mr-auto q-ma-sm">
        <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
        <q-breadcrumbs-el :label="$t('affiliate_bonus')" exact />
      </q-breadcrumbs>
    </div>
    <q-page padding>
      <header-affiliate-bonus :campaignList="campaignList" :channelList="sites" :bonusTypeList="bonusTypeList"></header-affiliate-bonus>
      <list-affiliate-bonus></list-affiliate-bonus>
      <form-affiliate-bonus :bonusTypeList="bonusTypeList" :campaigns="campaignList" :sites="sites"></form-affiliate-bonus>
      <form-upload-affiliate-bonus />
    </q-page>
  </q-layout>
</template>

<script>
import HeaderAffiliateBonus from '../../components/campaign/HeaderAffiliateBonus.vue';
import ListAffiliateBonus from '../../components/campaign/ListAffiliateBonus.vue';
import FormAffiliateBonus from '../../components/campaign/FormAffiliateBonus.vue';
import FormUploadAffiliateBonus from '../../components/campaign/FormUploadAffiliateBonus.vue';
import AffiliateService from '../../services/AffiliateService';

export default {
  components: { HeaderAffiliateBonus, ListAffiliateBonus, FormAffiliateBonus, FormUploadAffiliateBonus },
  mixins: [AffiliateService],
  name: 'AffilateBonus',

  created() {
    this.getSites();
    this.getCampaigns();
    this.LoadBonusType();
  },

  data() {
    return {
      sites: [],
      campaignList: [],
      bonusTypeList: []
    };
  },

  methods: {
    async LoadBonusType() {
        try {
            const { data, status } = await this.getBonusType();
            if (status === 200) {
            this.bonusTypeList = data;
            }
        } catch (error) {
            if (error.response && error.response.status === 500)
            this.errorNotify(this.$t('problem_try_again_later'));
            else this.errorNotify(error);
        }
    },

    async getCampaigns() {
      try {
        const { data, status } = await this.$http.get('/redirect?app=ADVERTISER&path=/api/get/campaign/all');
        if (status === 200) {
          this.campaignList = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      }
    },

    async getSites() {
      try {
        const { data, status } = await this.$http.get('/redirect?app=AFFILIATE&path=/api/affiliate/site/filter');
        if (status === 200) {
          this.sites = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      }
    }
  }
};
</script>
